module.exports = __webpack_public_path__ + "static/img/dlgcc.2f4b3705.png";